import Nullstack from 'nullstack';
export default function IconWallpaperOff({
  size = 24,
  color = "currentColor",
  stroke = 2
}) {
  const allProps = {
    width: size,
    height: size,
    "stroke-width": stroke,
    stroke: color
  };
  return Nullstack.element("svg", {
    xmlns: "http://www.w3.org/2000/svg",
    class: "inline-flex icon icon-tabler icon-tabler-wallpaper-off",
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    "stroke-width": "2",
    stroke: "currentColor",
    fill: "none",
    "stroke-linecap": "round",
    "stroke-linejoin": "round",
    ...allProps
  }, "   ", Nullstack.element("path", {
    stroke: "none",
    d: "M0 0h24v24H0z",
    fill: "none"
  }), "   ", Nullstack.element("path", {
    d: "M10 6h8a2 2 0 0 1 2 2v8m-.58 3.409a1.994 1.994 0 0 1 -1.42 .591h-12"
  }), "   ", Nullstack.element("circle", {
    cx: "6",
    cy: "18",
    r: "2"
  }), "   ", Nullstack.element("path", {
    d: "M8 18v-10m-3.427 -3.402c-.353 .362 -.573 .856 -.573 1.402v12"
  }), "   ", Nullstack.element("path", {
    d: "M3 3l18 18"
  }), " ");
}